/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is library for typechecking of props
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// Material Kit 2 React components
import MDBox from "dashboard/components/MDBox";
import MDAvatar from "dashboard/components/MDAvatar";
import MDTypography from "dashboard/components/MDTypography";
import MDButton from "dashboard/components/MDButton";
import { motion } from "framer-motion";
import { useTheme, Icon, Divider, Grid, IconButton, Tooltip, Badge, CircularProgress } from "@mui/material";
import DividerWithText from "dashboard/components/Costum/Divider";
import useCart from "hooks/useCart";

function DefaultReviewCard({ id, color, image, name, date, review,reactions, category,route, price, priceSold, priceOrigin, setSelectedProduct,view, handleLikeProduct, likedAlready, isPartner, updateProduct, isLoading, dist_id  }) {
  const theme = useTheme();
  const { addItem } = useCart();

  return (
    <MDBox
      variant={color === "transparent" ? "contained" : "gradient"}
      bgColor={color}
      borderRadius="xl"
      shadow={color === "transparent" ? "none" : "md"}
      p={0}
    >
    <Grid  container>
      <Grid xs={view ? 4 : 12} item>
      {image ? ( 
          <MDBox
          component="img"
          src={image}
          alt={name}
          borderRadius="lg"
          width="100%"
          position="relative"
          zIndex={1}
          onError={({ currentTarget }) => {
            /*eslint-disable*/
            currentTarget.onerror = null; // prevents looping
            currentTarget.src=`${process.env.REACT_APP_PUBLIC_URL}/img/product-default.png`;
          }}
          onClick={setSelectedProduct}
          sx={{objectFit:"cover", height :"100%" , width :"100%"}}
        />)
        :(<MDAvatar
          src={image}
          alt={name}
          variant="rounded"
          size="lg"
          shadow="md"
          sx={{ mt: -5, mb: 1 }}
          onClick={setSelectedProduct}
        />)
      }
      </Grid>
      <Grid xs={view ? 8 : 12} p={{xs:.5,lg:2}} item>
      <MDBox  lineHeight={1}>
        {category && <DividerWithText left={view} fontSize={16} color={color === "transparent" || color === "light" ? "text" : "white"}>
          {category}
        </DividerWithText>}
        <MDTypography
          display="flex"
          justifyContent={view && "space-between"}
          variant="h5"
          fontWeight="bold"
          color={color === "transparent" || color === "light" ? "dark" : "white"}
          sx={{color:"#1b1b1b", textShadow:' 0px 1px 0 #bdbbbb'}}
          mb={0.5}
        >
          {name} 
        </MDTypography>
        
        <MDTypography
          variant={image ? "caption" : "button"}
          fontWeight="regular"
          lineHeight={1}
          color={color === "transparent" || color === "light" ? "text" : "white"}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Icon>schedule</Icon>&nbsp;
          {date}
        </MDTypography>
      </MDBox> 
      {/* {price  && <MDBox mt={!view ? 1 : -2.5} mb={1} textAlign={view ? "right" : "left"}>
          <MDTypography color={color === "transparent" || color === "light" ? "text" : "white"} variant="body2" component="div" >
            {priceSold !== 0 ? 
              (<><small style={{textDecoration:"line-through"}}>{price.original}</small> - <h4 style={{display:"inline"}}>{price.sold}</h4></>)      
            : price.original}
          </MDTypography>
      </MDBox>} */}
      {review && view && <MDTypography
        variant="body2"
        component="div"
        className="review-headers"
        color={color === "transparent" || color === "light" ? "text" : "white"}
        my={1}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: "3",
          WebkitBoxOrient: "vertical",
        }}
      >
        {review}
      </MDTypography>}
      
      <motion.div
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
            style={{display:"flex", marginLeft : "auto", width:"fit-content"}}
           >
            <MDButton
              component={Link}
              to={route}
              variant="gradient"
              size="small"
              color="light"
              mt={1}
            >
            Plus de details
            </MDButton>
          </motion.div>
      {price && (<><Divider  sx={{opacity:1, mb:1, background:"white"}}  />
        <MDBox sx={{ display:"flex",justifyContent:"space-around",alignItems:"center", minHeight:40, width: view ? "60%" : "100%", float: view ? "right" : "none"}}>
              <Tooltip title="Add to cart" placement="top" arrow>
                <motion.div
                    whileHover={{ scale: 1.2, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].light }}
                    transition={{ type: "spring", stiffness: 300, damping: 10, mass: 1 }}
                    initial={{scale:1, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].dark}}
                  >
                  <IconButton onClick={()=>addItem({id, productName:name, price : priceSold === 0 ? priceOrigin : priceSold ,quantity:1})} size="small" sx={{p:.5}} color="white"  aria-label="add to cart">
                      <Icon  >shopping_cart</Icon>
                  </IconButton>
                </motion.div>
              </Tooltip>
              <Tooltip title="Quick details" placement="top" arrow>
                <motion.div
                     whileHover={{ scale: 1.2, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].light }}
                    transition={{ type: "spring", stiffness: 300, damping: 10, mass: 1 }}
                    initial={{scale:1, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].dark}}
                  >
                  <IconButton size="small"  onClick={setSelectedProduct} sx={{p:.5}} color="white" aria-label="show">
                      <Icon >search</Icon>
                  </IconButton>
                </motion.div>
              </Tooltip>
              {isPartner && <Tooltip title={`${dist_id ? "Supprimer de" : "Ajouter à"} ma liste`} placement="top" arrow>
                <motion.div
                    whileHover={{ scale: 1.2, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].light }}
                    transition={{ type: "spring", stiffness: 300, damping: 10, mass: 1 }}
                    initial={{scale:1, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].dark}}
                    >
                  {isLoading ? <CircularProgress size={20} color="info"  /> : <IconButton onClick={()=>updateProduct({ id : dist_id, update : dist_id ? "delete" : ({product_id : Number(id), distributer_id : isPartner})  })} size="small" sx={{p:.5}} color={dist_id ? "info": "white"} aria-label="compare">
                      <Icon>{dist_id ? "cancel" : "add_circle"}</Icon>
                  </IconButton>}
                </motion.div>
              </Tooltip>}
              <Tooltip title={likedAlready ? "supprimer" : "favorit"} placement="top" arrow>
                <motion.div
                    whileHover={{ scale: 1.2, color : color === "transparent" || color === "light" ? "text" : theme.palette[color].light }}
                    transition={{ type: "spring", stiffness: 300, damping: 10, mass: 1 }}
                    initial={{scale:1, color : color === "transparent" || color === "light" ? "text" : "white"}}
                    >
                  <Badge badgeContent={reactions} max={reactions} color="error">
                    <IconButton onClick={()=>handleLikeProduct({id, reaction : likedAlready ? "dislike" : "like"})} size="small" sx={{p:.5}} color={!likedAlready ? "white" : "primary"} aria-label={likedAlready ? "supprimer" : "favorit"}>
                        <Icon >{likedAlready ? "favorite" : "favorite_outlined"}</Icon>
                    </IconButton>
                  </Badge>
                </motion.div>
              </Tooltip>
        </MDBox></>)}
      </Grid>
      </Grid>
    </MDBox>
  );
}

// Setting default values for the props of DefaultReviewCard
DefaultReviewCard.defaultProps = {
  color: "transparent",
  image: "",
  review:"",
  price:""
};

// Typechecking props for the DefaultReviewCard
DefaultReviewCard.propTypes = {
  color: PropTypes.oneOf([
    "transparent",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light"
  ]),
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  review: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  price: PropTypes.oneOfType([PropTypes.string,PropTypes.shape({
    original: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
    sold: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
  })]),
};

export default DefaultReviewCard;
